/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { SystemUserStatusCssClasses, SystemUserStatusTitles } from "../../SystemUsersUIHelpers";

export const StatusColumnFormatter = (cellContent, row) => (
  <span
    className={`label label-lg label-light-${
      SystemUserStatusCssClasses[row.isActive]
    } label-inline`}
  >
    {SystemUserStatusTitles[row.isActive]}
  </span>
);